import React from 'react';
import './GrindIntroPage.css';
import grindImage from './assets/grind-goals.png';
import { useNavigate } from 'react-router-dom';

function GrindIntro() {
  const navigate = useNavigate();

  return (
    <div className="grind-intro-container">
      <h1 className="grind-intro-heading">
        Create YOUR journey to become the best wrestler you can be
      </h1>
      <img
        src={grindImage}
        alt="GRIND Goals Framework"
        className="grind-intro-image"
      />
      <p className="grind-intro-quote">
        "Greatness comes from hard work. Stay on the GRIND!"
      </p>
      <button
        className="grind-intro-button"
        onClick={() => navigate('/goals')}
      >
        🎯 What are your GRIND Goals?
      </button>
    </div>
  );
}

export default GrindIntro;
